<script>
import checkbox from "@/components/fields/List.vue";
import radio from "@/components/fields/Radio.vue";
import Range from "@/components/fields/Range.vue";
import TextField from "@/components/fields/TextField.vue";
import NumberField from "@/components/fields/NumberField.vue";
import Multiselect from "@/components/fields/Multiselect.vue";
import { GET, POST, errorNotification } from "@/shared/api";

export default {
  name: "combinationForm",
  props: {
    properties: [],
    product_title: "",
    product_code: null,
    selected_product: {},
  },
  data() {
    return {
      specification: [],
      choosenProduct: null,
      newCode: "",
      units: [],
      formState: {
        // code_system: [],
        farm_code: "",
        farm_value_code: "",
        stat_code: "",
        stat_value_code: "",
        shaffof_code: "",
        shaffof_value_code: "",
        name: "",
        unit_name: "",
        mxik_code: "",
        name_en: "",
        name_uz: "",
        tnvd_code: "",
      },
      codeTracker: {
        product_code: this.product_code,
        container: {},
        new_code: null,
      },
    };
  },
  components: {
    checkbox,
    radio,
    Range,
    TextField,
    NumberField,
    Multiselect,
  },

  watch: {
    properties(new_value) {
      if (Array.isArray(new_value)) {
        let fields = [...new_value];
        fields = fields.filter((el) => el.title !== null);
        this.choosenProduct = new_value;
        this.makeSpecification();
      }
    },
    product_title() {
      this.codeTracker.product_code = this.product_code;
      this.codeTracker.container = {};
      this.codeTracker.new_code = null;
      this.specification = [];
      this.formState = {
        // code_system: [],
        name: "",
        unit_name: "",
        mxik_code: "",
        name_en: "",
        name_uz: "",
        tnvd_code: "",
      };
      this.$refs.form.reset();
    },
  },
  methods: {
    submit() {
      // this.addCode();
      let ready = true;
      this.choosenProduct.forEach((el) => {
        this.update(
          {
            title: el.title,
            value: el.value,
            model: el,
          },
          false
        );
      });

      this.choosenProduct.forEach((el) => {
        if (el.isRequired && el.invalid) {
          ready = false;
        }
      });

      if (ready) {
        this.postCombination();
      }
    },
    postCombination() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          POST(
            {
              ...this.formState,
              product_id: this.selected_product.id,
              new_code: this.codeTracker.new_code,
            },
            "/combination",
            this,
            true
          ).then((response) => {
            this.clearFormState();
            this.$refs.form.reset();
          });
        }
      });
    },
    clearFormState() {
      this.formState = {
        // code_system: [],
        farm_code: "",
        farm_value_code: "",
        stat_code: "",
        stat_value_code: "",
        shaffof_code: "",
        shaffof_value_code: "",
        name: "",
        unit_name: "",
        mxik_code: "",
        name_en: "",
        name_uz: "",
        tnvd_code: "",
      };
      this.codeTracker.product_code = this.product_code;
      this.codeTracker.container = {};
      this.codeTracker.new_code = null;
      this.specification = [];
      this.$emit("formClear");
    },
    // addCode() {
    //   const trimmed = this.newCode.trim();
    //   if (trimmed && !this.formState.code_system.includes(trimmed)) {
    //     this.formState.code_system.push(trimmed);
    //     this.newCode = "";
    //   }
    // },
    // removeCode(index) {
    //   this.formState.code_system.splice(index, 1);
    // },

    getValues(params = {}, model = {}, value = []) {
      GET(params, `/product/query/${model.id}`, this, false)
        .then((response) => {
          model.value
            .map((val) => {
              return model.values.filter((item) => item == val);
            })
            .forEach((el) => {
              if (el.length > 1) {
                errorNotification(
                  this,

                  `Выбранное значение (${el[0]}) является дубликатом, обратитесь к администратору, в противном случае будет сгенерирован неверный код`
                );
                throw new Error(
                  `Duplicate value: ${el[0]} selected, model: ${model.title}`
                );
              }
            });

          const matches = response.filter((item) => value.includes(item.value));
          if (!this.codeTracker.container[model.title]) {
            this.$set(this.codeTracker.container, model.title, {});
          }

          if (!value.length) {
            delete this.codeTracker.container[model.title];
          } else {
            this.codeTracker.container[model.title].field_num = model.index;
            this.codeTracker.container[model.title].value_nums = matches
              .map((item) => Number(item.index))
              .sort((a, b) => a - b);
          }

          const sortedEntries = Object.values(this.codeTracker.container).sort(
            (a, b) => a.field_num - b.field_num
          );

          const parts = sortedEntries.map((entry) => {
            return entry.field_num + ";" + entry.value_nums.join(";");
          });

          const result = parts.join("/");
          this.codeTracker.new_code = this.product_code + "/" + result;

          const idx = this.choosenProduct.findIndex(
            (col) => col.id === model.id
          );
          this.$set(this.choosenProduct[idx], "value", value);
        })
        .catch((err) => {
          console.error("GET error:", err);
        });
    },
    update({ title, value, model = null }, make_request = true) {
      if (typeof value === "undefined") {
        return;
      }
      if (typeof title === "undefined") {
        return;
      }
      if (model !== null) {
        let index = null;
        this.specification.forEach((f, i) => {
          if (model.id === f.id) {
            index = i;
          }
        });
        if (index !== null) {
          if (make_request) {
            this.getValues({ mode: "values" }, model, value);
          }
          this.$set(this.specification, index, this.updateField(model, value));
        }
      }
    },
    updateField(field, value) {
      let f = field;
      if (["number", "text"].includes(field.inputType)) {
        f.value = value;

        if (
          field.isRequired &&
          (typeof field.value === "undefined" || field.value == null)
        ) {
          f.invalid = true;
        } else {
          f.invalid = false;
        }
      } else if (
        ["boolean", "multiselect", "checkbox"].includes(field.inputType)
      ) {
        f.value = value;

        if (
          field.isRequired &&
          (typeof field.value === "undefined" ||
            field.value == null ||
            field.value.length === 0)
        ) {
          f.invalid = true;
        } else {
          f.invalid = false;
        }
      } else if (field.inputType === "radio") {
        if (
          field.isRequired &&
          (typeof value === "undefined" || value == null)
        ) {
          f.invalid = true;
        } else {
          f.value = value;
          f.invalid = false;
        }
      } else if (field.inputType === "range") {
        if (
          Array.isArray(value) &&
          typeof value !== "undefined" &&
          value !== null
        ) {
          value.forEach((va) => {
            f = this.handleRangeUpdate(field, va);
          });
        } else {
          f = this.handleRangeUpdate(field, value);
        }
      }

      return f;
    },
    makeSpecification() {
      this.specification = this.choosenProduct;
      this.specification.map((el) => {
        const newEl = el;
        if (newEl.inputType === "list" && !newEl.value) {
          newEl.value = [];
        } else if (newEl.inputType === "range" && !newEl.value) {
          newEl.value = {};
        } else if (!newEl.value) {
          newEl.value = null;
        }
        return newEl;
      });
    },
    renderView(inputName) {
      if (inputName === "number") {
        return "NumberField";
      }
      if (inputName === "boolean") {
        return "radio";
      }
      if (inputName === "text") {
        return "TextField";
      }
      if (inputName === "multiselect") {
        return "Multiselect";
      }
      return inputName;
    },

    handleRangeUpdate(field, value) {
      const f = field;
      const newVal = [];
      if (Object.keys(f.value).length === 0) {
        // if object empty create emty array
        f.value = [];
      }
      let pushed = false;
      f.value.forEach((val) => {
        if (val.index === value.index && value.check) {
          pushed = true;
        }
        if (val.check) {
          newVal.push(val);
        }
      });
      if (!pushed && value.check) {
        newVal.push(value);
      }

      f.value = newVal;

      if (Object.keys(f.value).length === 0 && f.isRequired) {
        f.invalid = true;
      }
      return f;
    },
    getUnits() {
      GET([], "/unit", this, false).then((response) => {
        this.units = response;
        console.log(response);
      });
    },
  },
  mounted() {
    this.getUnits();
  },
};
</script>

<template>
  <div class="specification">
    <div
      class="d-flex flex-wrap justify-content-between align-items-center head-wrapper"
    >
      <h1 class="head-title specification__title">
        {{
          this.product_title.length > 50
            ? this.product_title.slice(0, 50) + "..."
            : this.product_title
        }}
      </h1>
      <h4 class="text-muted card-body code">
        {{
          codeTracker.new_code
            ? codeTracker.new_code
            : "Код еще не сгенерирован"
        }}
      </h4>
    </div>

    <div class="tabs specification__tabs">
      <div class="tabs__panel">
        <div class="tabs__pane">
          <div class="tabs__top tabs__top--characters">
            <div class="row">
              <div
                v-for="(item, i) in choosenProduct"
                :key="i"
                class="col-lg-6"
              >
                <component
                  v-if="item.title !== null"
                  :is="renderView(item.inputType)"
                  :model="item"
                  @update="update"
                />
              </div>
            </div>
            <ValidationObserver ref="form">
              <!-- <div class="form-group mt-3">
                <label>Система кодов</label>

                <div class="position-relative">
                  <input type="text" class="form-control" @keyup.enter="addCode" v-model="newCode"
                         :required="!formState.code_system.length"/>
                  <button
                    type="button"
                    class="btn add btn-sm position-absolute"
                    style="top: 50%; right: 10px; transform: translateY(-50%);"
                    @click="addCode"
                  ><i class="fa fa-plus"></i>
                  </button>
                </div>
                <span v-if="!formState.code_system.length" class="text-danger text-sm">Обязательное поле</span> -->
              <!-- <ValidationProvider rules="required" v-slot="{ errors }" class="w-100">

                               </ValidationProvider> -->
              <!-- <div
                  v-if="formState.code_system.length"
                  class="mt-2 codes-wrapper d-flex justify-content-start align-items-center flex-wrap ">
                  <div
                    class="code-wrapper bg-light"
                    v-for="(code, index) in formState.code_system"
                    :key="index"
                  >
                    <span>{{ code }}</span>
                    <button
                      class="code-x-btn danger"
                      @click="removeCode(index)"><i class="fa fa-remove"></i></button>
                  </div>
                </div> -->

              <!-- <ValidationProvider rules="required" v-slot="{ errors }" class="w-100">
                                 <input type="text" class="form-control" v-model="formState.code_system" required/>
                                 <span class="text-danger text-sm">{{ errors[0] }}</span>
                               </ValidationProvider> -->

              <!-- </div> -->
              <div class="row">
                <div class="form-group mt-3 col-lg-6">
                  <label>Код фарм</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="formState.farm_code"
                    required
                  />
                </div>
                <div class="form-group mt-3 col-lg-6">
                  <label>Код значения фарм</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="formState.farm_value_code"
                    required
                  />
                </div>
              </div>
              <div class="row">
                <div class="form-group mt-3 col-lg-6">
                  <label>Стат код</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="formState.stat_code"
                    required
                  />
                </div>
                <div class="form-group mt-3 col-lg-6">
                  <label>Код значения стат</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="formState.stat_value_code"
                    required
                  />
                </div>
              </div>
              <div class="row">
                <div class="form-group mt-3 col-lg-6">
                  <label>Код шаффоф</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="formState.shaffof_code"
                    required
                  />
                </div>
                <div class="form-group mt-3 col-lg-6">
                  <label>Код значения шаффоф</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="formState.shaffof_value_code"
                    required
                  />
                </div>
              </div>

              <div class="form-group mt-3">
                <label>ИКПУ кодов</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formState.mxik_code"
                  required
                />
              </div>
              <div class="form-group mt-3">
                <label>ТН ВЭД кодов</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formState.tnvd_code"
                  required
                />
              </div>
              <div class="form-group">
                <label>Названия (RU)</label>
                <ValidationProvider v-slot="{ errors }" class="w-100">
                  <input
                    type="text"
                    class="form-control"
                    rules="required"
                    v-model="formState.name"
                    required
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label>Названия (UZ)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formState.name_uz"
                  required
                />
              </div>
              <div class="form-group">
                <label>Названия (EN)</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formState.name_en"
                  required
                />
              </div>
              <div class="form-group">
                <label>Значения</label>
                <select
                  class="form-control"
                  v-model="formState.unit_name"
                  required
                >
                  <option
                    v-for="unit in units"
                    :key="unit.id"
                    :value="unit.title"
                    class="form-option"
                  >
                    {{ unit.title }}
                  </option>
                </select>
              </div>
            </ValidationObserver>
            <div class="d-flex flex-row-reverse">
              <button
                @click="submit"
                class="btn btn-warning"
                style="width: 300px"
              >
                Сохранять
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/scss/specification.scss";

.head-wrapper {
  gap: 15px;

  .text-muted {
    text-align: right;
    box-shadow: 0px 5px 25px rgba($black, 0.08);
  }
}

.row {
  display: flex;
}

.codes-wrapper {
  gap: 4px;

  .code-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      padding: 3px 0 3px 3px;
    }

    .code-x-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      color: #fb5858;

      &:active {
        border: none;
        outline: none;
      }
    }
  }
}
.form-option {
  color: red;
}
</style>
